enum ValidatorsType {
    UNBONDED = 1,
    UNBONDING = 2,
    ACTIVE = 3,
}

export default ValidatorsType;
